'use client'
import { useEffect } from 'react'

import styles from '@components/shared/error/styles.module.scss'
import { Link } from '@components/shared/link'
import { routes } from '@constants/routes'
import { datadogLogs } from '@services/datadog/datadog-logs'

const BASIC_ERROR = 'Something went wrong'

interface ErrorComponentProps {
  error?: Error
  title?: string
  route?: string
  linkCopy?: string
  onClick?: () => void
}

const Error = ({
  error,
  title,
  route,
  linkCopy,
  onClick,
}: ErrorComponentProps) => {
  useEffect(() => {
    if (!error) return

    datadogLogs.logger.info(title ?? BASIC_ERROR, {}, error)
  }, [error, title])

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title ?? BASIC_ERROR}</div>
      <Link
        className={styles.link}
        href={route ?? routes.Home()}
        onClick={(e) => {
          if (!onClick) return
          e.stopPropagation()
          e.preventDefault()
          onClick()
        }}
      >
        {linkCopy ?? 'Return to home page'}
      </Link>
    </div>
  )
}

export default Error
